import { createPortal } from 'react-dom'

interface Props {
  rect: DOMRect
  padding?: number
  radius?: number
}

/**
 * Renders a full-viewport dim overlay with a "spotlight" cutout over the
 * target element. Uses the CSS box-shadow spread trick so no canvas / SVG
 * is required. pointer-events: none so the highlighted element stays clickable.
 */
export default function TourSpotlight({ rect, padding = 8, radius = 12 }: Props) {
  return createPortal(
    <div
      aria-hidden="true"
      style={{
        position: 'fixed',
        top: rect.top - padding,
        left: rect.left - padding,
        width: rect.width + padding * 2,
        height: rect.height + padding * 2,
        borderRadius: radius,
        // The enormous spread creates the dim effect *outside* this element
        boxShadow: '0 0 0 9999px rgba(15, 14, 10, 0.65)',
        zIndex: 9000,
        // Critical: let clicks pass through to the highlighted element
        pointerEvents: 'none',
        transition: 'top 0.18s ease, left 0.18s ease, width 0.18s ease, height 0.18s ease',
      }}
    />,
    document.body,
  )
}
